var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPenta(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ff9b00",
    d: "M13 .2l12.174 8.845-4.65 14.31H5.476L.826 9.045z"
  })));
}
export default __webpack_public_path__ + "static/_/shared/assets/svg/multikills/penta.svg";
export { SvgPenta as ReactComponent };